export default {
	authorizeAndSaveButton: "Authorize and save",
	title: "New Meeting Recurrence",
	editTitle: "Edit Meeting Recurrence",
	saveButton: "Save recurrence",
	cancelButton: "Cancel",
	deleteButton: "Delete recurrence",

	meetingNameLabel: "Meeting name",
	meetingLinkHint: "The Zoom or Meet link for this meeting. We'll automatically send Teaming Assistant to your meeting.",
	meetingLinkLabel: "Meeting link",
	meetingFrequencyLabel: "Meeting frequency",
	meetingTemplateHint: "Adds the selected meeting template to each new instance.",
	meetingTemplateLabel: "Meeting template",
	meetingTemplatePlaceholder: "Select a template",
	noTemplateOptionText: "No template",
	timezoneLabel: "Time of day",
	startDateLabel: "Start date",
	daysLabel: "On these days",
	daysHint: "Select one of more days of the week when this meeting occurs.",
	dayOffsetLabel: "On this day",

	weekx1OptionText: "Weekly",
	weekx2OptionText: "Every 2 weeks",
	weekx3OptionText: "Every 3 weeks",
	weekx6OptionText: "Every 6 weeks",
	monthx1OptionText: "Every month",
	monthx2OptionText: "Every 2 months",
	monthx3OptionText: "Every 3 months",
	monthx6OptionText: "Every 6 months",

	sundayShortLabel: "Sun",
	mondayShortLabel: "Mon",
	tuesdayShortLabel: "Tue",
	wednesdayShortLabel: "Wed",
	thursdayShortLabel: "Thu",
	fridayShortLabel: "Fri",
	saturdayShortLabel: "Sat",

	sundayLongLabel: "Sunday",
	mondayLongLabel: "Monday",
	tuesdayLongLabel: "Tuesday",
	wednesdayLongLabel: "Wednesday",
	thursdayLongLabel: "Thursday",
	fridayLongLabel: "Friday",
	saturdayLongLabel: "Saturday",

	offset1OptionText: "1st",
	offset2OptionText: "2nd",
	offset3OptionText: "3rd",
	offset4OptionText: "4th",
};
